<!-- results-table.component.html -->
<h1 mat-dialog-title><strong>{{action | translate}}</strong> usuario <span *ngIf="action == 'Delete'"> {{LOCAL_DATA.nombre}}</span></h1>
<div mat-dialog-content >
  <ng-template *ngIf="action === 'Reset'">
    Seguro quiere reiniciar el password al usuario <b>{{LOCAL_DATA.correoElectronico}}</b>?
  </ng-template>
  <ng-template *ngIf="action === 'Delete'">
    Seguro quiere eliminar al usuario <b>{{LOCAL_DATA.correoElectronico}}</b>?
  </ng-template>

  <div fxLayout="column">
    <mat-form-field *ngIf="action != 'Delete' && action != 'Reset'" class="select-full" fxFlex="100">
      <input placeholder="Correo electrónico" matInput [(ngModel)]="LOCAL_DATA.correoElectronico" (blur)="validarUsuarioPorCorreo(LOCAL_DATA.correoElectronico)">
    </mat-form-field>
    <mat-form-field *ngIf="action != 'Delete' && action != 'Reset'" class="select-medio" fxFlex="100">
      <input placeholder="Nombre" matInput [(ngModel)]="LOCAL_DATA.nombre">
    </mat-form-field>
    <mat-form-field *ngIf="action != 'Delete' && action != 'Reset'" fxFlex="100">
      <input placeholder="Apellido" matInput [(ngModel)]="LOCAL_DATA.apellido">
    </mat-form-field>

    <mat-form-field fxFlex="100" *ngIf="action != 'Delete' && action != 'Reset'">
      <mat-chip-list #chipList aria-label="Tipo de usuario">
        <mat-chip
          *ngFor="let tipo of LOCAL_DATA.tipos"
          [selectable]="selectable"
          [removable]=true
          (removed)="remove(tipo)">
          {{tipo.nombre}}
          <mat-icon matChipRemove >cancel</mat-icon>
        </mat-chip>
        <input
          placeholder="Perfil de usuario"
          #usuarioInput
          [formControl]="myControl"
          [matAutocomplete]="auto"
          [matChipInputFor]="chipList"
          [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
          >
      </mat-chip-list>
      <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
        <mat-option *ngFor="let tipo of filteredTipos | async" [value]="tipo">
          {{tipo.nombre}}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>
  </div>

  <div class="content p-24" *ngIf="action === 'View'">

      <button mat-button (click)="openDialog()" mat-flat-button color="primary" class="add-row">Agregar Nodo/Estructura</button>

      <table mat-table [dataSource]="LOCAL_DATA.estructuras" #mytable class="my-table mat-elevation-z8">

        <ng-container matColumnDef="estructura">
          <th mat-header-cell *matHeaderCellDef> Estructura </th>
          <td mat-cell *matCellDef="let element"> {{element.padre.nombre}} </td>
        </ng-container>
        
        <ng-container matColumnDef="nombre">
          <th mat-header-cell *matHeaderCellDef> Nodo </th>
          <td mat-cell *matCellDef="let element"> {{element.nombre}} </td>
        </ng-container>


        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>

  </div>

  <div class="content p-24" *ngIf="action === 'View'">

    <table mat-table [dataSource]="LOCAL_DATA.evaluaciones" #mytablePreiniciado class="my-table mat-elevation-z8">

      <ng-container matColumnDef="nombre">
        <th mat-header-cell *matHeaderCellDef> Nombre </th>
        <td mat-cell *matCellDef="let element"> {{element.nombre}} </td>
      </ng-container>

      <ng-container matColumnDef="estado">
        <th mat-header-cell *matHeaderCellDef> Estado </th>
        <td mat-cell *matCellDef="let element"> {{element.estado?.nombre}} </td>
      </ng-container>

      <ng-container matColumnDef="version">
        <th mat-header-cell *matHeaderCellDef> Versión </th>
        <td mat-cell *matCellDef="let element"> {{element.version}} </td>
      </ng-container>

      <ng-container matColumnDef="estructuraJerarquica">
        <th mat-header-cell *matHeaderCellDef> Estructura Jerarquica </th>
        <td mat-cell *matCellDef="let element"> {{element.estructuraJerarquica?.nombre}} </td>
      </ng-container>

      <ng-container matColumnDef="creador">
        <th mat-header-cell *matHeaderCellDef> Creador </th>
        <td mat-cell *matCellDef="let element"> {{element.creador?.nombreCompleto}} </td>
      </ng-container>

      <ng-container matColumnDef="dueno">
        <th mat-header-cell *matHeaderCellDef> Dueño </th>
        <td mat-cell *matCellDef="let element"> {{element.owner?.nombreCompleto}} </td>
      </ng-container>

      <ng-container matColumnDef="fechaInicio">
        <th mat-header-cell *matHeaderCellDef> Fecha de inicio </th>
        <td mat-cell *matCellDef="let element"> {{element.fechaInicio | date:'dd/MM/yyyy'}} </td>
      </ng-container>

      <ng-container matColumnDef="fechaFin">
        <th mat-header-cell *matHeaderCellDef> Fecha de finalización </th>
        <td mat-cell *matCellDef="let element"> {{element.fechaFin | date:'dd/MM/yyyy'}} </td>
      </ng-container>


      <tr mat-header-row *matHeaderRowDef="displayedColumnsEvaluaciones"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumnsEvaluaciones;"></tr>
    </table>
  </div>
</div>
<div mat-dialog-actions >
  <button mat-button (click)="doAction()" *ngIf="action != 'View'">{{action | translate}}</button>
  <button mat-button (click)="closeDialog()" mat-flat-button color="warn">{{'Cancel' | translate}}</button>
</div>
